import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { find, get } from 'lodash';
import { Observable, throwError } from 'rxjs';
import { first, mergeMap, skipWhile } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ComposableService } from '../services/composable.service';
import { ApiService } from 'src/app/services/api.service';
import { NavigationService } from '../services/navigation.service';
import { CommonService } from '../services/common.service';


import {
  AppState,
  ADD_APP_ID,
  ADD_APPLICATION_ID,
  UPDATE_AGENT,
} from '../app-reducer';
@Component({
  selector: 'dmeo-decision',
  templateUrl: './demo-decision.component.html'
})

export class DemoDecisionComponent implements OnInit {
  appState$: Observable<any>;
  inFEageRange = false;
  decisionTitle = '';
  decisionMsg = '';
  processing: boolean;
  decisionMsgType:any;
  productName:any;
  faceAmount:any;
  agentEmailAddress:any;
  processError:any;
  processTimeout:any;
  riskClass: any;
  smokerStatus:any;
  AgentId: string;
  AgentFirstName: string;
  AgentLastName: string;
  AgentEmailAddress: string;
  JH_NEW_BUSINESS_FORMS_URL: string;
  JH_REFERENCE_GUIDE_URL: string;
  isLoggedInViaSalesHub = false;
  
  constructor(
    private store: Store<AppState>,
    private router: Router,
    private apiService: ApiService,
    private composableService: ComposableService,
    private navigationService: NavigationService,
    private commonService: CommonService


  ) {
    this.appState$ = store.select('sections');


  }
  backToMiniPortal(){
    window['setTimeout'](() => {
      // erase app memory to prevent old case data from displaying in agent's next case
      this.composableService.resetApplication();
      //set to NOT demo application
      this.appState$.pipe(first()).subscribe((state: any) => {
        state.isDemo = false;
        this.commonService.logAppState(state);
      });
      // go to the mini-portal
      this.router.navigate(['express', 'financial-professional']);
    }, 3000);
  }
  ngOnInit() {
    this.processing=false;
    this.processError=true;
       // grab producer credentials from ISAM headers
       if (window['jhConfig'].ivuser !== '') {
        this.AgentId = window['jhConfig'].ivuser;
        if (this.AgentId != 'DreamFinFit') {
          this.isLoggedInViaSalesHub = true;
        }
      } else {
        if (window['jhConfig'].env === 'production') {
          window.location.reload();
        } else {
          // DO NOT TOUCH
          // so it shows up on dev local
          this.AgentId = 'DreamFinFit';
        }
      }
  
      if (window['jhConfig'].firstname  !== '' &&  window['jhConfig'].lastname  !== '') {
        this.AgentFirstName = window['jhConfig'].firstname;
        this.AgentLastName = window['jhConfig'].lastname;
      } else {
        // so it shows up on dev local
        this.AgentFirstName = 'Dream';
        this.AgentLastName = 'FinFit';
      }
  
      if (window['jhConfig'].email  !== '' ) {
        this.AgentEmailAddress = window['jhConfig'].email;
      } else {
        // so it shows up on dev local
        this.AgentEmailAddress = 'test@test.com';
      }
  
      // other config values
      this.JH_NEW_BUSINESS_FORMS_URL = window['jhConfig'].JH_NEW_BUSINESS_FORMS_URL;
      this.JH_REFERENCE_GUIDE_URL = window['jhConfig'].JH_REFERENCE_GUIDE_URL;
  
     
  }
  updateString(msg:any){
    if(msg){
      return msg.replace(/([A-Z])/g, ' $1').replace(/^./, function(str){ return str.toUpperCase(); });
    }else{
      return msg;
    }
  }
   // start new application
   startDemoApplication() {
    this.appState$.pipe(first()).subscribe((state: any) => {
      state.isDemo = true;
      this.commonService.logAppState(state);
    });
    this.processing = true;

    // start eApp
    const data = {};

    // subscribe to application changes
    this.apiService.startDemoApplication(data).pipe(
      mergeMap((response: any) => {
        // error handling
        if (get(response, 'code') !== 200 || !get(response, 'data.ApplicationId')) {
          return throwError(response);
        }

        // update store
        this.store.dispatch({
          type: ADD_APP_ID,
          payload: get(response, 'data.AppAuthId')
        });

        // update store
        this.store.dispatch({
          type: ADD_APPLICATION_ID,
          payload: get(response, 'data.ApplicationId')
        });

        // update store
        this.store.dispatch({
          type: UPDATE_AGENT,
          payload: {
            agentFirstname: this.AgentFirstName,
            agentLastname: this.AgentLastName,
            agentEmail: this.AgentEmailAddress,
            agentPhoneNumber: '555-55-5555',
          }
        });

        return this.appState$;
      }),
      first(),
      mergeMap((response: any) => {
        const requestPayload = {
          appAuthId: response.appAuthId,
          AgentId: this.AgentId,
          estimateDetails: get(response, 'estimateDetails'),
          salesSource: get(response, 'salesSource '),
          payload: {
            agentPhoneNumber: '555-55-5555',
            agentInfo: get(response, 'payload.agentInfo') || null
          },
          agentFirstname: this.AgentFirstName,
          agentLastname: this.AgentLastName,
          agentEmail: this.AgentEmailAddress

        };

        const processAppPayload = {
          AppAuthId: response.appAuthId,
          AppId: response.appId,
          AgentId: this.AgentId,
          AgentFirstName: this.AgentFirstName,
          AgentLastName: this.AgentLastName,
          AgentEmail: this.AgentEmailAddress
        };

        this.apiService.processApplication(processAppPayload).subscribe(  res => {
          console.log(res);
        }, (error) => {
            console.log('ERROR');
            console.log(error);
            this.processing = false;
        });

        return this.apiService.saveInfo(requestPayload);
      }),
    ).subscribe((response) => {

			// trigger observable holding block submissions until application pre-processing is done
			this.navigationService.readyToSubmit(true);

    }, (errorResponse) => {
      this.navigationService.nextSectionRelative('error');
    });

    // enter eApp
    this.goToEapp();
  }
  goToEapp() {
    // go to next section
    this.appState$.pipe(
      // tslint:disable-next-line:indent
      skipWhile((state: any) => {
        return (state.formData === null) || (state.questions === null);
      }),
      first()
    ).subscribe((state) => {
			if (state.questions) {
			  const routes = this.router.config;
			  const newRoutes = routes.map(item => {
          const { data } = item;
          if (data && data.blockHeading && data.blockName && data.blockName !== 'intake' && data.hasOwnProperty('isProgressRoute')) {
            const questionBlocks = find(state.questions, { Name: data.blockName });
            item.data.blockCategory = questionBlocks.BlockCategory || null;
            item.data.blockHeading = questionBlocks.DisplayName || null;
          }
          return item;
			  });
        this.navigationService.buildNavStore(newRoutes);
			};
      this.navigationService.nextSectionRelative('proposed-insured');
      
    });
  }
}
